import { render, staticRenderFns } from "./CurrencyRateDetails.vue?vue&type=template&id=764dca76&"
import script from "./CurrencyRateDetails.vue?vue&type=script&lang=js&"
export * from "./CurrencyRateDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports